import React, { useContext, useEffect, useState } from 'react'
import cn from 'classnames'
import styles from './Item.module.sass'
import Users from './Users'
import Control from './Control'
import Options from './Options'
import { get, post } from '../../adapters/api'
import config from '../../config'
import { useParams } from 'react-router'
import Player from '../../components/Player'
import { fromWei } from 'web3-utils'
import { toUsd } from '../../adapters/eth'
import { Web3Context } from '../../contexts/Web3Context'
import Nft from '../../contracts/ERC721Full'
import getVideoId from 'get-video-id'
import { Menu, Dropdown, Button, message } from 'antd'
import { DownOutlined, RightOutlined } from '@ant-design/icons'
import TextInput from '../../components/TextInput'

const navLinks = ['Owners']

const Item = () => {
  const [activeIndex, setActiveIndex] = useState(0)
  const [tokenInfo, setTokenInfo] = useState({})
  const [categories, setCategories] = useState()
  const [users, setUsers] = useState()
  const [video, setVideo] = useState()

  const { seo_url } = useParams()

  const { rate, defaultAccount, signMgs } = useContext(Web3Context)

  const menu = (
    <Menu>
      <Menu.Item key="1">
        <a target="_blank" rel="noopener noreferrer" href={config.ipfsUri + tokenInfo.uri}
           className={cn(styles.submenu_item)}>
          <span>
             <img src="/images/content/icons/ipfs.png" alt="IPFS Explorer"/>
              View on IPFS
          </span>
          <RightOutlined style={{ fontSize: '10px', color: '#08c' }}/>
        </a>
      </Menu.Item>
      <Menu.Item key="2">
        <a target="_blank" rel="noopener noreferrer" className={cn(styles.submenu_item)}
           href={config.explorer + '/token/' + Nft.networks[config.networkId].address + '?a=' + tokenInfo.token_id}>
          <span>
            <img src="/images/content/icons/ethscan.png" alt="Blockchain exploerer" className={cn(styles.circle)}/>
            View on Blockchain explorer
          </span>
          <RightOutlined style={{ fontSize: '10px', color: '#08c' }}/>
        </a>
      </Menu.Item>
    </Menu>
  )

  useEffect(() => {
    (async () => {
      try {
        const info = await get('token/item/' + seo_url)
        if (info.data.category_id_categories) {
          setCategories(info.data.category_id_categories)
        }
        if (info.data.users) {
          setUsers(info.data.users)
        }
        if (info.data) {
          setTokenInfo(info.data)
        }
      }
      catch (e) {
      }
    })()
  }, [seo_url]) //on initial render

  const handleChangeVideo = (event) => {
    const id = getVideoId(event.target.value)
    if (id.service === 'youtube') {
      setVideo('https://www.youtube.com/embed/' + id.id)
    }
  }

  const updateItem = async (event) => {
    event.preventDefault()
    try {
      const sign = await signMgs({ id: tokenInfo.id, video: video })

      if (!sign) {
        message.error('Error on change profile')
        return false
      }

      const result = await post('token/update', { sign, from: defaultAccount, id: tokenInfo.id, video: video })
      if (result) {
        message.success('Token card will be changes soon')
        window.location.reload()
      }

      return false
    }
    catch (e) {
      console.error(e)
      message.error('Error on change token card')
      return false
    }
  }

  return (
    <>
      <div className={cn('section item-details-page', styles.section)}>
        <div className={cn('container', styles.container)}>
          <div className={styles.bg}>
            <div className={styles.preview}>
              <div className={styles.categories}>
                {categories && categories.map((x, index) => (
                  <div
                    className={cn(
                      { 'status-black': index % 2 === 0 },
                      { 'status-purple': index % 2 === 1 },
                      styles.category,
                    )}
                    key={index}
                  >
                    {x.category}
                  </div>
                ))}
              </div>
              {tokenInfo && tokenInfo.local_uri &&
              <Player item={tokenInfo} sizes={{ h: 768, w: 640 }}/>
              }
            </div>
            {tokenInfo && <Options className={styles.options} item={tokenInfo} users={users}/>}
          </div>
          <div className={styles.details}>
            <h1 className={cn('h3', styles.title)}>{tokenInfo.name}</h1>
            <div className={styles.cost}>
              <div className={cn('status-stroke-green', styles.price)}>
                {fromWei(tokenInfo.price || '0', 'ether')}&nbsp;{config.symbolName}
              </div>
              <div className={cn('status-stroke-black', styles.price)}>
                ${toUsd(tokenInfo.price || '0', rate)}
              </div>

              <Dropdown overlay={menu} trigger={['click']}>
                <Button className={cn(styles.btn_dropdown)}>
                  VIEW PROOF <DownOutlined/>
                </Button>
              </Dropdown>

            </div>
            <div className={styles.info}>{tokenInfo.description}</div>
            <div className={styles.nav}>
              {navLinks.map((x, index) => (
                <button
                  className={cn(
                    { [styles.active]: index === activeIndex },
                    styles.link,
                  )}
                  onClick={() => setActiveIndex(index)}
                  key={index}
                >
                  {x}
                </button>
              ))}
            </div>
            {activeIndex === 0 && (
              <Users className={cn(
                { [styles.active]: 0 === activeIndex },
                styles.users)} items={users}/>
            )}
            {tokenInfo && <Control
              className={styles.control}
              token={tokenInfo}
            />}

            {tokenInfo && tokenInfo.video &&
            <div className={styles.youtube_container}>
              <iframe width="100%" height="315" src={tokenInfo.video} title="YouTube video player"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      frameBorder="0" allowFullScreen/>
            </div>
            }
            {defaultAccount === tokenInfo.currentOwner &&
            <div className={styles.youtube_form}>
              <TextInput
                className={styles.field}
                label="Youtube Video (optional)"
                name="name"
                type="text"
                placeholder="Insert Youtube Video about your token if you have it"
                value={video}
                onChange={handleChangeVideo}
              />
              <div className={styles.btns}>
                <button className={cn('button', styles.button)} onClick={updateItem}>
                  Update Token Card
                </button>
              </div>
            </div>}
          </div>
        </div>
      </div>
    </>
  );
};

export default Item;
